import { graphql } from "../generated";

export const CreateNote = graphql(`
  mutation CreateNote($callId: ID!, $content: String!) {
    createNote(callId: $callId, content: $content) {
      id
      callId
      content
      createdAt
      userId
    }
  }
`);
